export function getModifiedRowValue(value: number): string {
  if (value > 1000) {
    return `${(value / 1000).toFixed(2)} K$`;
  } else {
    return `${value.toFixed(2).toString()}$`;
  }
}